/* eslint-disable no-unused-vars */
import i18n from 'i18next';

import api from '@utils/api'

import { setCatalogLanguageTabs, setCatalogLanguageItems } from '@actions/catalogs'

import { SET_CATALOG } from '@constants/actionType'

import {
  StatusVisible,
} from '@constants/general'

export const getAllLanguagesList = (querys) => async (dispatch, getState) => {
  const response = await api.getListLanguages(querys)
    if (querys.type === 'all' && !response?.status) {
      await dispatch({
        type: SET_CATALOG,
        payload: {nameCatalog: 'languagesCatalog', data: response.data}
      })
  }
  return response
}

export const reOrderLanguage = (data) => async (_dispatch, _getState) => {
  const response = await api.reOrderLanguage(data)
  return response;
};

export const newLanguage  = ({ name, code }) => async (_dispatch, _getState) => {
  const data = {
    nombre: name,
    clave: code,
  }
  const response = await api.addCLanguage(data)
  return response;
};

export const editLanguage  = ({clave, name, justification}) => async (_dispatch, _getState) => {
  const data = {
    clave,
    nombre: name,
    reason: justification
  }
  const response = await api.editLanguage(data)
  return response
};
export const deleteLanguage  = ({clave, justification}) => async (_dispatch, _getState) => {
  const data = {
    reason: justification
  }
  const response = await api.deleteLanguage(clave, data)
  return response
};

export const updateVisibilityStatus = ({ clave, justification, visible }) => async (_dispatch, _getState) => {
  let validateStatus = null
  if (visible === StatusVisible.IS_VISIBLE) validateStatus = 'hide'
  if (visible === StatusVisible.IS_HIDDEN) validateStatus = 'show'
  const data = {
    status: validateStatus,
    reason: justification
  }
  const response = await api.updateVisibilityLanguage(clave, data)
  return response;
};

export const getDictionaryLanguage = (clave) => async (_dispatch, _getState) => {
  const response = await api.getDictionaryLanguage(clave)
  return response;
};

export const updatetextDictionary = ({clave, key, value}) => async (_dispatch, _getState) => {
  const data = {
    word: key,
    value
  }
  const response = await api.updateTextDictionary(clave, data)
  if (!response?.status) {
    i18n.addResource(clave, 'translation',key, value)
    i18n.changeLanguage(i18n.language);
  }
  return response;
};

export const getListDictionariesProcessLanguage = () => async (_dispatch, _getState) => {
  const response = await api.getListDictionariesProcessLanguage()
  return response;
};

export const getDictionaryProcess = (url, clave) => async (_dispatch, _getState) => {
  const querys = {
    path: url
  }
  const response = await api.getDictionaryProcess(clave, querys)
  return response;
};

export const updatetextDictionaryProcess = ({clave, key, value, path}) => async (_dispatch, _getState) => {
  const data = {
    word: key,
    value,
    url: path
  }
  const response = await api.updatetextDictionaryProcess(clave, data)
  return response;
};

export const deleteTextDictionary = (data = []) => async (_dispatch, _getState) => {
  const response = await api.deleteTextDictionary(data)
  return response;
};

export const deleteTextProcessDictionary = ({path, data}) => async (_dispatch, _getState) => {
  const body = {
    path,
    data
  }
  const response = await api.deleteTextProcessDictionary(body)
  return response;
};

export const addTextDictionary = (newTextObj) => async (_dispatch, _getState) => {
  const response = await api.addTextDictionary(newTextObj)
  return response;
};

export const addTextProcessDictionary = ({newTextObj, path}) => async (_dispatch, _getState) => {
  const data = {
    path,
    data: newTextObj
  }
  const response = await api.addTextProcessDictionary(data)
  return response;
};